import { Select, Typography } from "antd"
import { Flex } from "antd"
import style from "../styles/displaySettings.module.scss"
import React from "react"
import { MATCH_TYPES } from "../../../constants/campaign.constants"
import { matchTypesEnum } from "../../../types/customers"
import { setStateType } from "../../../types/setStateType"

interface IMatchTypeSelect {
  setMatchType: setStateType<matchTypesEnum>
  matchType: matchTypesEnum
}

const MatchTypesSelect: React.FC<IMatchTypeSelect> = ({ setMatchType, matchType }) => {
  const { Text } = Typography

  return (
    <div>
      <Flex vertical>
        <Select
          className={style.state_select}
          onChange={(value) => setMatchType(value)}
          value={matchType}
        >
          {MATCH_TYPES.map((campaignState) => (
            <Select.Option key={campaignState} value={campaignState}>
              {campaignState}
            </Select.Option>
          ))}
        </Select>
        <Text type="secondary">Match type</Text>
      </Flex>
    </div>
  )
}

export default MatchTypesSelect
